/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

import smcrypto from 'sm-crypto';


// 获取当前时间
export function getNowFormatTime(dateObj = null) {
  const date = dateObj ? dateObj : new Date(new Date().getTime())
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  const hour = date.getHours()
    .toString()
    .padStart(2, '0')
  const minute = date.getMinutes()
    .toString()
    .padStart(2, '0')
  const second = date.getSeconds()
    .toString()
    .padStart(2, '0')
  if (month >= 1 && month <= 9) {
    month = `0${month}`
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = `0${strDate}`
  }
  const currentdate = `${year + '-' + month + '-' + strDate + ' ' + hour + ':' + minute + ':' + second}`
  return currentdate
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time, 10)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time *= 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = `0${value}`
    }
    return value || 0
  })
  return time_str
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  }

  const childrenListMap = {}
  const nodeIds = {}
  const tree = []

  for (const d of data) {
    const parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }

  return tree
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = `${encodeURIComponent(propName)}=`
    if (value !== null && value !== '' && typeof (value) !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof (value[key]) !== 'undefined') {
            const params = `${propName}[${key}]`
            const subPart = `${encodeURIComponent(params)}=`
            result += `${subPart + encodeURIComponent(value[key])}&`
          }
        }
      } else {
        result += `${part + encodeURIComponent(value)}&`
      }
    }
  }
  return result
}

// 返回项目路径
export function getNormalPath(p) {
  if (p.length === 0 || !p || p === 'undefined') {
    return p
  }
  const res = p.replace('//', '/')
  if (res[res.length - 1] === '/') {
    return res.slice(0, res.length - 1)
  }
  return res
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}

// 格式化树形结构为 value label格式
export function parseTree(data, isMenu = true, valueName = 'id', labelName = 'name') {
  const ret = {
    nodes: [],
    values: []
  }
  ret.nodes = parseTree2(data, isMenu, valueName, labelName, ret)
  return ret
}

export function parseTree2(data, isMenu, valueName, labelName, ret) {
  const nodes = []
  data.forEach((el) => {
    const parent = {
      value: el[valueName],
      label: el[labelName],
    }
    if (isMenu) {
      if (el.checked.toString() === 'true') {
        ret.values.push(el[valueName])
      }
    } else if (el.parentId === parent.value) {
      ret.values.push(el[valueName])
    }
    if (el.children && el.children.length > 0) {
      parent.children = parseTree2(el.children, isMenu, valueName, labelName, ret)
    }
    nodes.push(parent)
  })
  return nodes
}

export function numberToString(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return '数据非法' // 判断数据是否大于0
  }

  let unit = '千百拾亿千百拾万千百拾元角分'
  let str = ''
  n += '00'

  const indexpoint = n.indexOf('.') // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2) // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length) // 若为整数，截取需要使用的unit单位
  for (let i = 0; i < n.length; i++) {
    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i) // 遍历转化为大写的数字
  }

  return str.replace(/零(千|百|拾|角)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(万|亿|元)/g, '$1')
    .replace(/(亿)万|壹(拾)/g, '$1$2')
    .replace(/^元零?|零分/g, '')
    .replace(/元$/g, '元整') // 替换掉数字里面的零字符，得到结果
}

export function valueToLabel(value, options) {
  let label = ''
  for (let i = 0; i < options.length; i++) {
    const item = options[i]
    if (item.value === value) {
      label = item.label
      break
    }
  }

  return label
}

// 格式化日期为"年-月-日"格式
function formatDate(date) {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString()
    .padStart(2, '0')
  const day = date.getDate()
    .toString()
    .padStart(2, '0')

  return year + '-' + month + '-' + day
}

export function getThisWeekDates() {
  const today = new Date()
  const currentDay = today.getDay() // 获取当前日期是星期几（0-6，0 表示周日）

// 计算本周一的日期
  const monday = new Date(today)
  monday.setDate(today.getDate() - (currentDay === 0 ? 6 : currentDay - 1))

// 计算本周日的日期
  const sunday = new Date(today)
  sunday.setDate(today.getDate() + (currentDay === 0 ? 0 : 7 - currentDay))

  // 格式化开始日期和结束日期
  const startDateString = formatDate(monday)
  const endDateString = formatDate(sunday)

  // 创建一个数组，存储本周一至本周日的日期
  let allDates = []
  for (let i = 0; i < 7; i++) {
    const date = new Date(monday.getTime() + i * 24 * 60 * 60 * 1000)
    allDates.push(formatDate(date))
  }
  return {
    dates: allDates,
    startDate: startDateString + ' 00:00:00',
    endDate: endDateString + ' 23:59:59'
  }
}

export function getThisMonthDates() {
  const today = new Date()
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

  const endOfMonth = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0)

  // 格式化开始日期和结束日期
  const startDateString = formatDate(startOfMonth)
  const endDateString = formatDate(endOfMonth)

  return {
    startDate: startDateString + ' 00:00:00',
    endDate: endDateString + ' 23:59:59'
  }
}

export function getMonthsWithWithDates(year) {
  const currentDate = new Date() // 获取当前日期
  const currentYear = currentDate.getFullYear() // 获取当前年份
  const months = []

  for (let y = year; y <= currentYear; y++) {
    const startMonth = 0
    const endMonth = (y === currentYear) ? currentDate.getMonth() : 11 // 如果是当前年份，则截止到当前月份；否则截止到12月

    for (let month = startMonth; month <= endMonth; month++) {
      const startDate = new Date(y, month, 1) // 当前月份的开始日期
      const endDate = new Date(y, month + 1, 0) // 当前月份的结束日期

      const monthObject = {
        year: y,
        month: (month + 1).toString()
          .padStart(2, '0'),
        startDate: formatDate(startDate) + ' 00:00:00',
        endDate: formatDate(endDate) + ' 23:59:59'
      }

      months.push(monthObject)
    }
  }

  return months
}

export function getQuartersWithDates(year) {
  const currentDate = new Date() // 获取当前日期
  const currentYear = currentDate.getFullYear() // 获取当前年份
  const currentQuarter = Math.floor((currentDate.getMonth() + 1) / 3) // 获取当前季度
  const quarters = []

  for (let y = year; y <= currentYear; y++) {
    const startQuarter = 0
    const endQuarter = (y === currentYear) ? currentQuarter : 3 // 如果是当前年份，则截止到当前季度；否则截止到第四季度

    for (let quarter = startQuarter; quarter <= endQuarter; quarter++) {
      const startMonth = quarter * 3
      const endMonth = startMonth + 2

      let startDate = new Date(y, startMonth, 1) // 当前季度的开始日期（对应季度的第一个月份）
      let endDate = new Date(y, endMonth + 1, 0) // 当前季度的结束日期（对应季度的最后一个月份的下一个月的前一天）

      if (quarter === 0 && y === year) {
        startDate = new Date(year, 0, 1) // 如果是指定年份且是第一个季度，则将开始日期调整为一月一日
      }

      const quarterObject = {
        year: y,
        quarter: '季度' + (quarter + 1),
        startDate: formatDate(startDate) + ' 00:00:00',
        endDate: formatDate(endDate) + ' 23:59:59'
      }
      quarters.push(quarterObject)
    }
  }

  return quarters
}

export function getYearsWithDates(year) {
  const currentDate = new Date() // 获取当前日期
  const currentYear = currentDate.getFullYear() // 获取当前年份
  const years = []

  for (let y = year; y <= currentYear; y++) {
    const startDate = new Date(y, 0, 1) // 当前年份的开始日期（1月1日）
    const endDate = new Date(y, 11, 31) // 当前年份的结束日期（12月31日）

    const yearObject = {
      year: y,
      startDate: formatDate(startDate) + ' 00:00:00',
      endDate: formatDate(endDate) + ' 23:59:59'
    }

    years.push(yearObject)
  }

  return years
}

export function getDatesBetween(startDate, endDate) {
  const dates = []

  // 将字符串类型的日期转换为 Date 对象
  const start = new Date(startDate)
  const end = new Date(endDate)

  // 获取时间戳的毫秒数
  const startTime = start.getTime()
  const endTime = end.getTime()

  // 将 startDate 和 endDate 之间的所有日期存储到数组中
  for (let i = startTime; i <= endTime; i += 86400000) {
    const currentDate = new Date(i)
    const year = currentDate.getFullYear()
    const month = ('0' + (currentDate.getMonth() + 1)).slice(-2)
    const day = ('0' + currentDate.getDate()).slice(-2)
    const dateString = `${year}-${month}-${day}`
    dates.push(dateString)
  }

  return dates
}

export function getYearMonthsBetween(startTime, endTime) {
  const startDate = new Date(startTime)
  const endDate = new Date(endTime)
  const startYear = startDate.getFullYear()
  const startMonth = startDate.getMonth() + 1
  const endYear = endDate.getFullYear()
  const endMonth = endDate.getMonth() + 1
  const yearMonths = []

  for (let year = startYear; year <= endYear; year++) {
    let startMonthValue = year === startYear ? startMonth : 1
    let endMonthValue = year === endYear ? endMonth : 12
    for (let month = startMonthValue; month <= endMonthValue; month++) {
      month = month < 10 ? '0' + month : '' + month
      yearMonths.push(year + '-' + month)
    }
  }

  return yearMonths
}

// 空字符串转为null
export function convertEmptyStringsToNull(obj) {
  // 检查传入的是否是对象或数组
  if (obj && typeof obj === 'object') {
    Object.keys(obj)
      .forEach(key => {
        if (typeof obj[key] === 'string' && obj[key] === '') {
          // 如果属性值是空字符串，则将其转换为null
          obj[key] = null
        } else if (typeof obj[key] === 'object') {
          // 如果属性值是对象或数组，则递归调用该方法
          convertEmptyStringsToNull(obj[key])
        }
      })
  }
  return obj
}


export function extractPermissions(data) {
  let permissions = [];

  function recurse(items) {
    items.forEach(item => {
      if (item.permission) {
        permissions.push(item.permission);
      }
      if (item.children && item.children.length > 0) {
        recurse(item.children);
      }
    });
  }

  recurse(data);

  return permissions;
}

// 将16进制字符串转换为字节数组
function hexToBytes(hex) {
  // 确保16进制字符串的长度是偶数
  if (hex.length % 2 !== 0) {
    throw new Error('Invalid hex string');
  }

  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }

  return bytes;
}

// 将字节数组编码为Base64字符串
function bytesToBase64(bytes) {
  // 创建一个Blob对象并使用FileReader读取为Base64字符串
  const binaryString = Array.from(bytes).map(byte => String.fromCharCode(byte)).join('');
  return btoa(binaryString);
}
// const publicKey = "04e6680f417eb20d153fa8776ddc20b224c61f965d1aa0fe35e0c984304689ab82b6ad410eb84d26aa0ad66659e6ecf7e0848a1ffee51335826aac6ad7e01ca876"
// // SM2 加密
// export function  encrypt (plaintext) {
//   try {
//     if (!smcrypto || !smcrypto.sm2) {
//       throw new Error('SM2 module not properly initialized');
//     }
//     const cipherMode = 1; // 1 - C1C3C2，0 - C1C2C3，默认为1
//      // 加密结果
//     const hex = smcrypto.sm2.doEncrypt(plaintext, publicKey, cipherMode)
//     let bytes = hexToBytes(hex)
//     return bytesToBase64(bytes)
//   } catch (error) {
//     console.error('SM2 encryption error:', error);
//     return null;
//   }
// }

const sm4Key = 'fc5869f8421bc9a0fac793995755f77b'; // SM4需要16字节的密钥（32位16进制字符）

/**
 * SM4加密函数（ECB模式）
 * @param {string} plaintext - 明文
 * @returns {string|null} Base64编码的加密结果
 */
export function encrypt(plaintext) {
  try {
    if (!smcrypto?.sm4) {
      throw new Error('SM4模块未正确初始化');
    }
    
    // 参数校验
    if (!plaintext || typeof plaintext !== 'string') {
      throw new Error('无效的明文');
    }
    
    // 转换明文为UTF-8字节数组
    const plainBytes = new TextEncoder().encode(plaintext);
    
    // SM4加密（ECB模式）
    const encryptedHex = smcrypto.sm4.encrypt(
      plaintext, 
      sm4Key,
      { 
        mode: 'ecb', 
        inputEncoding: 'utf8', 
        outputEncoding: 'hex' 
      }
    );
    
    // 转换为Base64
    return bytesToBase64(hexToBytes(encryptedHex));
  } catch (error) {
    console.error('SM4加密错误:', error);
    return null;
  }
}